<template>
  <div class="containerHome">
    <div v-if="loading" class="text-center">
      <v-progress-circular
          class="mt-auto"
          :size="70"
          :width="7"
          color="primary"
          indeterminate
      ></v-progress-circular>
    </div>
    <div v-else>
      <h1>Bienvenid@</h1>
      <div class="headerHome">
        <div v-if="dataHome" class="userWelcome">
          <h2>{{ dataHome.adminFirstName }} {{ dataHome.adminLastName }}</h2>
          <h3>{{ dataHome.companyName }}</h3> 
        </div>
        <div v-else>
          <h3>Aquí lograrás manejar la información acorde a las categorías, productos y usuarios.</h3>
          <h6>Cualquier inquietud Lucasian te puede ayudar</h6>
        </div>
        <div class="iconWelcome">
          <change_image v-if="dataHome" :image="dataHome.companyLogo"/>
          <change_image v-else :image="logo"/>
        </div>
      </div>
      <homeWhiteboard :data="dataHome"/>
    </div>
  </div>

 
</template>

<script>

  import homeWhiteboard from '@/views/home/pages/components/home_whiteboard.vue';
  import change_image from '@/shared/components/change_image/change_image_component.vue';
  import  EventBus  from '@/utils/event_bus.js'; 
  import {
    WELCOME_M,
    GET_WELCOME,
    GET_STATE_LOADING,
    ACTION_WELCOME,
  } from "@/views/home/store/types/types.js";

  import { mapActions, mapGetters } from "vuex";

  export default {
    name: "home_page",
    components: {
      homeWhiteboard,
      change_image
    },
    data(){
      return{
        logo: "https://beneflex-icons.s3.amazonaws.com/clients/logo1.svg"
      }
    },
    async mounted() {
      await this.getActionwelcome();
      EventBus.$on('marca-succesfull', () => {
        this.getActionwelcome();
      });
    },
    methods: {
      ...mapActions({
        getActionwelcome: `${WELCOME_M}${ACTION_WELCOME}`
      }),
    },
    computed: {
      ...mapGetters({
        dataHome: [`${WELCOME_M}${GET_WELCOME}`],
        loading: `${WELCOME_M}${GET_STATE_LOADING}`
      }),
    },
  };

</script>

<style lang="css" scoped>

  /* Define los estilos (Tipo de letra) para las etiquetas h1,h2,h3,h4,h5,h6   */
  body {
    font-family: "Nunito Sans", sans-serif;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: "Amsi Pro", sans-serif;
    color: #2d0049;
    font-weight: normal;
  } 


  .headerHome {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 20vh;
    margin: 5vh 8vh 5vh 12vh;
  }

  .iconWelcome{
    margin-left: 4vh;
  }

  h1, h3, h6 {
    font-family: 'Amsi Pro',  sans-serif;
    color: #2D0049;
    font-weight: normal;
  }

  @media screen and (max-width: 900px) {
    h1 {
      font-size: 3vh;
      text-align: center;
    }

    h3 {
      font-size: 2vh;
    } 
  }

  
  @media screen and (max-width: 414px) {
        
        h1{
            font-size:3vh;
            margin-left:2vh
        }
      }
    
      @media screen and (min-width: 414px) {
        
        h1{
          font-size:4vh;
          margin-left:2vh
        }
      }
    
      @media screen and (max-width: 280px) { 
    
        h1{
          font-size:3vh;
          margin-left:2vh
        }
        h2{
          font-size:2vh;
          margin-left: 11vh;
        }
        .headerHome{
          margin: 6vh 0vh 6vh 0vh;
        }
      } 

</style>